import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RelatedArticles = ({ articles, title = "Related Articles" }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-brand p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="BookOpen" size={20} color="var(--color-primary)" />
        <h3 className="font-semibold">{title}</h3>
      </div>
      <div className="space-y-4">
        {articles?.map((article) => (
          <Link
            key={article?.id}
            to={`/news/${article?.slug}`}
            className="flex space-x-4 p-3 rounded-brand-sm hover:bg-muted/50 transition-brand group"
          >
            <div className="w-20 h-16 rounded-brand-sm overflow-hidden flex-shrink-0">
              <Image
                src={article?.image}
                alt={article?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-brand"
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="font-medium text-sm line-clamp-2 group-hover:text-primary transition-brand mb-1">
                {article?.title}
              </h4>
              
              <div className="flex items-center space-x-3 text-xs text-muted-foreground">
                <span>{formatDate(article?.publishedAt)}</span>
                <span className="flex items-center space-x-1">
                  <Icon name="Clock" size={12} />
                  <span>{article?.readTime} min</span>
                </span>
                <span className="flex items-center space-x-1">
                  <Icon name="Eye" size={12} />
                  <span>{article?.views}</span>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <Link
          to="/news"
          className="flex items-center justify-center space-x-2 text-sm text-primary hover:text-primary/80 transition-brand"
        >
          <span>View all articles</span>
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default RelatedArticles;